<template>
  <div class="header header-fixed header-auto-show header-logo-center">
    <router-link to="/home" class="header-title color-theme">TBD</router-link>
    <i @click="changeMode()" class="header-icon color-theme header-icon-4"><i
        class="fas fa-lightbulb"></i></i>
  </div>
</template>

<script>
import global from "../mixins/global";

import { mapMutations } from "vuex"
export default {
  mixins: [global],
  methods: {
    ...mapMutations(["updateMode"]),
    changeMode(){
      this.updateMode()
    }
  }
}
</script>

<style scoped>

</style>